<template>
  <component :is="component" v-if="component"/>
</template>

<script>
export default {
  name: "ImageEmptyLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    emptyLayout: '',
  },
  data() {
    return {
      component: null,

    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/information/ImageEmptyLayout')
        })

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.emptyLayout) {
        return null
      }
      return () => import(`@/template/information/${this.emptyLayout}`)
    },
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>